// Cipher's Voice — up to three first-person sentences of what the mind did while you
// were away (spec §6). TEXT IS STILL once present (Bible §1/§6): each sentence only
// FADES UP on arrival (voice-line, 300ms calm-out, staggered), then holds. Honest empty
// state when nothing real moved. No header, no card. aria-live so the narration reaches
// screen readers even under reduced motion.
import React, { useEffect, useState } from "react";
import { useReducedMotion } from "./lib/useReducedMotion";
import { motion } from "./lib/motion";

export default function CipherVoice({ voice, loading }) {
  const reduce = useReducedMotion();
  const [shown, setShown] = useState(reduce);
  const line = motion("voice-line", { reducedMotion: reduce });

  useEffect(() => {
    if (reduce) { setShown(true); return undefined; }
    setShown(false);
    const id = requestAnimationFrame(() => setShown(true));
    return () => cancelAnimationFrame(id);
  }, [voice, reduce]);

  if (loading) {
    // The lines "resolve in as the mind recalls" — not a spinner.
    return <p data-testid="voice-loading" className="text-sm text-slate-500">Recalling…</p>;
  }
  if (!voice) return null;

  const items = voice.empty ? [{ text: voice.emptyLine, kind: "empty" }] : voice.lines;

  return (
    <div data-testid="cipher-voice" role="status" aria-live="polite" className="max-w-2xl">
      <p className="text-[11px] uppercase tracking-wide text-slate-500">{voice.lead}</p>
      <div className="mt-1 space-y-1">
        {items.map((l, i) => (
          <p
            key={`${l.kind}-${i}`}
            data-testid={voice.empty ? "voice-empty" : `voice-line-${i}`}
            className="text-lg leading-snug text-slate-100"
            style={{
              opacity: shown ? 1 : 0,
              transition: reduce ? "none" : `opacity ${line.cssDuration} ${line.cssEasing}`,
              transitionDelay: reduce ? "0ms" : `${i * line.durationMs}ms`,
            }}
          >
            {l.text}
          </p>
        ))}
      </div>
    </div>
  );
}
